import { sort_center_api } from '@shared/api';

function cleanScannerCode(value: string): string {
  // eslint-disable-next-line no-control-regex
  return value.replace(/[\x00-\x1F\x7F]/g, '');
}

// Обычная этикетка посылки (без страны). Если этикетки нет, гейтвей отвечает 422 с причиной.
export async function getParcelLabel(trackNumber: string): Promise<Blob> {
  const cleanTrackNumber = cleanScannerCode(trackNumber);
  const url = `v1/parcels/${encodeURIComponent(cleanTrackNumber)}/label`;

  const response = await sort_center_api.get(url, {
    responseType: 'blob',
  });

  return new Blob([response.data], { type: 'application/pdf' });
}
